import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { Component } from "react";
import classNames from "classnames";
import { Toast } from "primereact/toast";
import { issuingApiService } from "../../services/api/Issuing/IssuingApiService";
import { CardInfo, getCardDesignLabel } from "../../models/IssuingClientsModel";
import history from "../../history";
import { Button } from "primereact/button";
import { Fieldset } from "primereact/fieldset";
import { Card, CardBody } from "reactstrap";
import { Info } from "lucide-react";

interface ClientCardsProps {
    IndividualId: number | undefined;
}

interface ClientCardsDefaultState {
    isLoading: boolean;
    cardsList: CardInfo[];
}

export default class ClientCardsComponent extends Component<ClientCardsProps, ClientCardsDefaultState> {
    toast: Toast | null = null;

    constructor(props: ClientCardsProps) {
        super(props);

        this.state = {
            isLoading: true,
            cardsList: []
        };
    }

    async componentDidMount() {
        const paymentMethodsResult = await issuingApiService.getClientICards(this.props.IndividualId!);
        if (!paymentMethodsResult.success) {
            this.setState({ isLoading: false });
            this.toast?.show({ severity: "error", summary: "Error", detail: paymentMethodsResult.message, life: 3000 });
            return;
        }

        this.setState({
            isLoading: false,
            cardsList: paymentMethodsResult.data,
        });
    }

    renderBadge(success: boolean, title: string) {
        return <div className={classNames("badge", "badge-" + (success ? "success" : "danger"))}>{title ? title : "Pending"}</div>;
    }
    onCardDetailsActionButtonClick = (card: CardInfo) => {
        history.push({
            pathname: `/issuing/card/${card.cardId}/${this.props.IndividualId}`
        });
    };
    onRowClick = (event: any) => {
        const card = event.data as CardInfo;
        this.onCardDetailsActionButtonClick(card);
    };

    actionBodyTemplate = (rowData: CardInfo) => {
        return <Button 
        icon={<Info size={16}/>}
        disabled={!rowData.cardStatus || rowData.cardStatus === null} type="button" outlined onClick={() => this.onCardDetailsActionButtonClick(rowData)} ></Button>;
    };

    renderClientCards = () => {
        return (
            <Card>
                <Toast ref={(el) => (this.toast = el)} />
                <CardBody>
                    <Fieldset legend="10N Cards" toggleable={true} collapsed={false}>

                        <DataTable value={this.state.cardsList} loading={this.state.isLoading}>
                            <Column field="cardId" header="Id" />
                            <Column field="cardPlasticType" header="Type" />
                            <Column
                                field="cardDesign"
                                header="Design"
                                body={(row: CardInfo) => getCardDesignLabel(row.cardDesign)}
                            />
                            <Column field="maskedPan" header="Masked PAN" />
                            <Column field="expiryDate" header="Expiry (YYMM)" />
                            <Column
                                field="cardStatus"
                                header="Status"
                                body={(row: CardInfo) =>
                                    this.renderBadge(row.cardStatus === "Active", row.cardStatus)
                                }
                            />
                            <Column
                                header="Details"
                                body={this.actionBodyTemplate}
                                headerStyle={{ width: "8em", textAlign: "center" }}
                                bodyStyle={{ textAlign: "center", overflow: "visible" }}

                            />
                        </DataTable>
                    </Fieldset>
                </CardBody>
            </Card>


        )
    };

    render() {
        return this.renderClientCards();
    }
}
